import React from 'react'
import { Link } from 'react-router-dom';
import "./whatsapp.css"
const Review = () => {
  return (
    <>
    <h1 className='bndf-review'>Give Review On</h1>
    <div className="statsContainer">
    <Link to="https://www.tripadvisor.in/UserReviewEdit-g293890-d34195441-Himalayas_Travels-Kathmandu_Kathmandu_Valley_Bagmati_Zone_Central_Region.html"target="_blank"><img src="/img/company/google.png" alt="df"className='googlebus' /></Link>
    <Link to="https://www.tripadvisor.in/UserReviewEdit-g293890-d34195441-Himalayas_Travels-Kathmandu_Kathmandu_Valley_Bagmati_Zone_Central_Region.html"target="_blank"><img src="/img/company/tripad.jpg" alt="df"className='googlebus' /></Link>
    <Link to="https://www.tripadvisor.in/UserReviewEdit-g293890-d34195441-Himalayas_Travels-Kathmandu_Kathmandu_Valley_Bagmati_Zone_Central_Region.html" target="_blank"><img src="/img/company/trust.png" alt="df"className='googlebus' /></Link>
  </div>
  </>
  )
}

export default Review